import React, { useState } from 'react'
import './HelpTickets.css'
import { Radio } from 'antd';
import HRTickets from './HRTickets';
import PRAAVISuportTicket from './PRAAVISuportTicket';
import { Modal } from "antd";

function HelpTickets() {
    const [size, setSize] = useState("hr");
    const [modal2Open, setModal2Open] = useState(false);

    const onChange = (e: RadioChangeEvent) => {
        setSize(e.target.value);
    };
    return (
        <div className='main-help'>
            <div className='flex justify-between help-teb'>
                <div className='flex HelpTabs mt-2'>
                    <Radio.Group value={size} onChange={onChange} >
                        <Radio.Button value="hr">HR Tickets</Radio.Button>
                        <Radio.Button value="praavi">PRAAVI Support Tickets</Radio.Button>
                        {/* <Radio.Button value="Whistleblower">Whistleblower complaints (only for BO)</Radio.Button> */}
                    </Radio.Group>
                </div>
                {/* <div className='mt-2'>
                    <span className='raise' onClick={() => setModal2Open(true)}>Raise Anonymouse Whistleblower complaint</span>
                </div> */}
            </div>
            <div>
                {size === 'hr' ? <HRTickets /> : size === 'praavi' ? <PRAAVISuportTicket /> : ''}
            </div>
            {/* <Modal
                centered
                open={modal2Open}
                onOk={() => setModal2Open(false)}
                onCancel={() => setModal2Open(false)}
                footer={false}
            >
                <div className="w-100 h-100">
                    <p className='help-raise'>Raise Anonymous Whistleblower complaint</p>
                    <div>
                        <input
                            placeholder="Subject"
                            className="model-input h-8 p-1 mt-4"
                        />      
                    </div>
                </div>
            </Modal> */}
        </div>
    )
}

export default HelpTickets